import React, { useState,useEffect } from 'react';
import './cancellationPolicyPage.css';
import Header from '../../components/common/header';
import Footer from '../../components/common/footer';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/userContext';
import { useCart } from '../../contexts/cartContext';


const CancellationPolicyPage = () => {
  const navigate = useNavigate()
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  const { checkSessionTokenExpirationStatus, handleRemoveLocalStorage } =
    useUser();
    const { fetchCartQuantity,cartQuantity,setCartQuantity ,handleQuantity} = useCart();
    const { setcityName, globalSearchTerm, setGlobalSearchTerm, setSessionCode, setUserId, setUsername, setUtmSessionId ,fetchCsrfToken} = useUser();
    useEffect(() => {
      fetchSeoMetaDetails()
      sessionStorage.removeItem("requestData");
      sessionStorage.removeItem("categoryType");
      sessionStorage.removeItem('categoryId');
      sessionStorage.removeItem('productId');
     
    }, []);

    useEffect(() => {
      const isSessionHandled = sessionStorage.getItem("sessionHandled");
    
      // If the session was already handled, avoid running this logic again
      if (isSessionHandled) return;
    
      // console.log("------>>>>>>>>>>>>>>>>>aboutus-------", checkSessionTokenExpirationStatus());
    
      if (checkSessionTokenExpirationStatus()) {
        // Clear session-related operations
        handleQuantity();
        handleRemoveLocalStorage();
    
        // Set the sessionHandled flag to true to prevent re-execution after reload
        sessionStorage.setItem("sessionHandled", "true");
    
        // Redirect to the homepage
        navigate("/");
    
        // Reload the page to clear cache
        window.location.reload();
      }
    }, []);

    const fetchSeoMetaDetails = async () => {
      try {
          const code = 'cancellation_policy_page'
          const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
            {  method: 'GET',
              headers:{
                // Accept:'aplication/json',
                "Content-Type": "application/json"
              },
              credentials: "include",
              mode:"cors"                       
            }
          );
          if (!response.ok) throw new Error('Failed to fetch categories');
          const data = await response.json();
          await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
      } catch (error) {
          //console.error('Error fetching categories:', error);
      }
    };
    
    const changeTitleAndMetaTags = async (
      title: string,
      metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
    ) => {
      try {
          // Update the document title
          if (title) {
              document.title = title;
          } else {
              document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
          }
    
          // Update or create meta tags
          Object.keys(metaTags).forEach((metaName) => {
              const metaTag = document.querySelector(`meta[name="${metaName}"]`);
              if (metaTag) {
                  // Update existing meta tag
                  metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
              } else {
                  // Create new meta tag if it doesn't exist
                  const newMetaTag = document.createElement('meta');
                  newMetaTag.name = metaName;
                  newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                  document.head.appendChild(newMetaTag);
              }
          });
    
          // Cleanup function to reset the title and meta tags when unmounting
          return () => {
              document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
              Object.keys(metaTags).forEach((metaName) => {
                  const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                  if (metaTag) {
                      metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                  }
              });
          };
      } catch (error) {
          //console.error("Error updating title and meta tags:", error);
      }
    };
    return (
      <div>
        <Header />
        <main className="main-content-cancellation-page container">
        <div className="section_breadcrumb">
        <div className="container-">
          <div className="row">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <a >Cancellation Policy</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
          <div className="tnc-page ">
            <h2>Cancellation Policy</h2>
            <div className="tnc-items">
              <p className="tnc-content">
                Thank You for choosing Selsmart! Attero Recycling Private
                Limited, is a company incorporated under the laws of India,
                having its registered office at 2, C/o Saraswati Press, Green
                Park, Dehradun 248001, Uttarakhand, India and corporate office
                at A-72/A, Sector-64, Noida 201301, Uttar Pradesh, India
                (“<strong>Selsmart</strong>”, “<strong>We</strong>”, “<strong>Our</strong>”, “<strong>Us</strong>”).
                <br />
              </p>

              <p className="tnc-content">
                We operate and manage www.selsmart.in (“<strong>Website</strong>”) to provide Our
                users (“<strong>You</strong>”, “<strong>Your</strong>”, “<strong>Yours</strong>”) a platform to sell Your used
                electronic and electrical products (“<strong>Product</strong>”) conveniently and
                effortlessly from the comfort of Your home or office.
                <br />
              </p>

              <p className="tnc-content">
                This Cancellation Policy (“<strong>Policy</strong>”) along with Our Terms and
                Conditions, Privacy Policy and Shipping Policy set out the
                procedure and conditions for the cancellation of Your order
                placed on Our Website. We request You to read the terms set out
                in this Policy. By accessing or using Our Website, You agree to
                be bound by this Policy. We may modify this Policy from time to
                time, with or without issuing You a notice. Your continued
                access or usage of this Website signifies Your acceptance of the
                updated Policy.
                <br />
              </p>

              <h3 className="tnc-sub-heading">
                Cancellation before pick-up schedule confirmation:
              </h3>
              <p className="tnc-content">
                You have the right to cancel Your order, free of charge, at any
                time before Your pick-up schedule is confirmed by Us. We cannot
                provide any cancellation for Your order in any circumstance
                after the pick-up of Your order is picked up by Us. You
                understand and acknowledge that We reserve the right to cancel
                Your order at any time at Our sole discretion.
              </p>

              <h3 className="tnc-sub-heading">Cancellation Process</h3>
              <p
                className="tnc-content"
                style={{ fontSize: "20px", fontWeight: "600" }}
              >
                You can cancel Your order by:
              </p>

              <ol className="tnc-order-list">
                <li className="">
                  Cancelling on the automatic IVR call
                </li>
                <li className="">
                  Calling the toll free number listed on the website
                </li>
              </ol>
              <h3 className="tnc-sub-heading">Cancellation Fees</h3>
              <p className="tnc-content">
                Your satisfaction is Our priority, and We believe in providing
                You with the flexibility of cancelling Your order. Whether You
                need to cancel due to unforeseen circumstances or a change of
                heart, You can do so without incurring any additional charges/
                cancellation fees.
              </p>

              <h3 className="tnc-sub-heading">Customer Support</h3>
              <p className="tnc-content">
                For any inquiries or assistance regarding order cancellations,
                feel free to reach out to us at:{" "}
                <a href="mailto:care@selsmart.in">care@selsmart.in</a>.
              </p>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
};

export default CancellationPolicyPage;
